(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || drawer.dataset.enhanced === 'true') return;
    drawer.dataset.enhanced = 'true';

    const panel = drawer.querySelector('.cart-drawer__panel');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const isMobile = window.matchMedia('(max-width: 46.875rem)');
    let scrollDismissEnabled = false;
    let drawerOpenedScrollPosition = 0;
    let closeFallbackTimer;

    const finishClose = () => {
      window.clearTimeout(closeFallbackTimer);
      if (drawer.open) drawer.close();
      drawer.classList.remove('is-closing', 'is-open');
      scrollDismissEnabled = false;
    };

    const close = () => {
      if (!drawer.open || drawer.classList.contains('is-closing')) return;

      if (prefersReducedMotion.matches) {
        finishClose();
        return;
      }

      scrollDismissEnabled = false;
      drawer.classList.add('is-closing');
      drawer.classList.remove('is-open');

      const handleTransitionEnd = (event) => {
        if (event.target !== panel || event.propertyName !== 'opacity') return;
        panel.removeEventListener('transitionend', handleTransitionEnd);
        finishClose();
      };

      panel.addEventListener('transitionend', handleTransitionEnd);
      closeFallbackTimer = window.setTimeout(() => {
        panel.removeEventListener('transitionend', handleTransitionEnd);
        finishClose();
      }, 350);
    };

    drawer.querySelector('[data-cart-drawer-close]')?.addEventListener('click', close);
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) close();
    });
    drawer.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });
    window.addEventListener('scroll', () => {
      if (!drawer.open || !scrollDismissEnabled) return;

      if (isMobile.matches) {
        const scrollDistance = Math.abs(window.scrollY - drawerOpenedScrollPosition);
        if (scrollDistance < 300) return;
      }

      close();
    }, { passive: true });

    document.addEventListener('cart:updated', async (event) => {
      const item = event.detail.item;
      const addedQuantity = event.detail.addedQuantity;
      let noticeText = '';
      if (event.detail.partialAdd) {
        noticeText = addedQuantity === 1
          ? drawer.dataset.partialAddMessageOne
          : drawer.dataset.partialAddMessageOther.replace('[quantity]', addedQuantity);
      }

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('Cart request failed');
        const cart = await response.json();

        document.querySelectorAll('[data-cart-count]').forEach((count) => {
          count.textContent = cart.item_count;
        });
        document.querySelectorAll('[data-mobile-cart-link]').forEach((link) => {
          link.hidden = cart.item_count === 0;
        });
        drawer.querySelector('[data-cart-drawer-count]').textContent = cart.item_count;
      } catch (error) {
        console.error(error);
      }

      drawer.querySelector('[data-cart-drawer-product]').textContent = item.product_title || item.title;
      drawer.querySelector('[data-cart-drawer-size]').textContent = event.detail.productSize || '';
      drawer.querySelector('[data-cart-drawer-price]').textContent = event.detail.productPrice || '';

      const notice = drawer.querySelector('[data-cart-drawer-notice]');
      notice.textContent = noticeText;
      notice.hidden = noticeText.length === 0;
      panel.classList.toggle('has-notice', noticeText.length > 0);

      const image = drawer.querySelector('[data-cart-drawer-image]');
      const imageUrl = item.featured_image?.url || item.image;
      if (imageUrl) {
        image.src = imageUrl;
        image.alt = item.featured_image?.alt || item.product_title || '';
        image.hidden = false;
      }

      if (!drawer.open) {
        window.clearTimeout(closeFallbackTimer);
        drawer.classList.remove('is-closing');
        drawer.classList.remove('is-open');
        drawerOpenedScrollPosition = window.scrollY;
        drawer.showModal();
        panel.getBoundingClientRect();
        drawer.classList.add('is-open');
        if (prefersReducedMotion.matches) {
          scrollDismissEnabled = true;
        } else {
          panel.addEventListener('transitionend', (event) => {
            if (event.propertyName !== 'opacity') return;
            if (drawer.open && drawer.classList.contains('is-open')) {
              scrollDismissEnabled = true;
            }
          }, { once: true });
        }
      }
      drawer.querySelector('[data-cart-drawer-close]')?.focus({ preventScroll: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-product-detail-image-src]').forEach((card) => {
    if (card.dataset.detailImagePreloadEnhanced === 'true') return;
    card.dataset.detailImagePreloadEnhanced = 'true';

    const preloadDetailImage = () => {
      if (card.dataset.detailImagePreloaded === 'true') return;
      card.dataset.detailImagePreloaded = 'true';

      const image = new Image();
      image.sizes = '(max-width: 750px) calc(100vw - 48px), 50vw';
      image.srcset = card.dataset.productDetailImageSrcset || '';
      image.src = card.dataset.productDetailImageSrc;
    };

    card.addEventListener('pointerenter', preloadDetailImage, { once: true });
    card.addEventListener('focus', preloadDetailImage, { once: true });
    card.addEventListener('touchstart', preloadDetailImage, { once: true, passive: true });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quantity-change]');
    if (!button || button.disabled) return;

    const control = button.closest('[data-quantity-input]');
    const input = control?.querySelector('input[name="quantity"]');
    if (!input) return;

    const change = Number(button.dataset.quantityChange);
    const minimum = Number(input.min) || 1;
    input.value = Math.max(minimum, (Number(input.value) || minimum) + change);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-quantity-input] input[name="quantity"]')) return;

    const input = event.target;
    const minimum = Number(input.min) || 1;
    input.value = Math.max(minimum, Number(input.value) || minimum);
    const minus = input.closest('[data-quantity-input]')?.querySelector('[data-quantity-change="-1"]');
    if (minus) minus.disabled = Number(input.value) <= minimum;
  });
  } catch(e) { console.error(e); }
})();

})();
